<div class="row">
  <div class="mb-4 col-lg-3">
    <label class="form-label">
      {{ 'productModule.resource' | translate }}
    </label>

    <div class="row">
      <div class="col-lg-9">
        <strong>
          {{
            serieProposal.details.initialRequest.productId
              | getTranslation : 'product' : 'description'
              | async
          }}
        </strong>
      </div>
    </div>
  </div>

  <div class="mb-4 col-lg-3">
    <label class="form-label">
      {{ 'general.location' | translate }}
    </label>

    <div class="row">
      <div class="col-lg-9">
        <strong>
          {{
            (locationEntities$ | async)[
              serieProposal.details.initialRequest.locationId
            ]?.description
          }}
        </strong>
      </div>
    </div>
  </div>

  <div class="mb-4 col-lg-6">
    <label class="form-label">
      {{ 'organizationModule.organization' | translate }}
    </label>

    <div>
      <strong>
        {{
          (organizationEntities$ | async)[serieProposal.organizationId]
            ?.description
        }}
        <span
          *ngIf="
            (organizationEntities$ | async)[serieProposal.organizationId]
              ?.abbreviation
          "
        >
          ({{
            (organizationEntities$ | async)[serieProposal.organizationId]
              ?.abbreviation
          }})
        </span>
      </strong>
    </div>
  </div>
</div>

<div class="row">
  <div class="mb-4 col-3">
    <label class="form-label">
      {{ 'general.startDate' | translate }}
    </label>

    <p class="mb-0">
      {{
        getSerieProposalDates().startDate
          | date : 'd MMMM yyyy' : null : (selectedLanguage$ | async)
      }}
    </p>
  </div>
  <div class="mb-4 col-3">
    <label class="form-label">
      {{ 'general.endDate' | translate }}
    </label>

    <p class="mb-0">
      {{
        getSerieProposalDates().endDate
          | date : 'd MMMM yyyy' : null : (selectedLanguage$ | async)
      }}
    </p>
  </div>

  <div class="mb-4 col-lg-6">
    <label class="form-label">
      {{ 'general.dateCreation' | translate }}
    </label>
    <p class="mb-0">
      {{
        serieProposal.createdAt.toString()
          | date : 'd MMMM yyyy' : null : (selectedLanguage$ | async)
      }}
    </p>
  </div>
</div>

<div class="row">
  <div class="col-lg-6">
    <div>
      <label class="form-label">
        {{ 'serieProposalModule.proposalType' | translate }}
      </label>
    </div>
    <div>
      <div class="nav nav-segment">
        <!-- REPEATABLE_BOOKING radio button -->
        <input
          type="radio"
          class="btn-check"
          name="proposalType"
          [value]="serieProposalType.REPEATABLE_BOOKING"
          id="repeatableBookingBtn"
          autocomplete="off"
          [checked]="
            serieProposal.type === serieProposalType.REPEATABLE_BOOKING
          "
          (click)="$event.preventDefault()"
        />
        <label class="nav-link" for="repeatableBookingBtn">
          {{ 'serieProposalModule.repeatableBooking' | translate }}
        </label>

        <!-- CUSTOM_DATE radio button -->
        <input
          type="radio"
          class="btn-check"
          name="proposalType"
          [value]="serieProposalType.CUSTOM_DATE"
          id="customDatesBtn"
          autocomplete="off"
          [checked]="serieProposal.type === serieProposalType.CUSTOM_DATE"
          (click)="$event.preventDefault()"
        />
        <label class="nav-link" for="customDatesBtn">
          {{ 'serieProposalModule.customDates' | translate }}
        </label>
      </div>
    </div>
  </div>

  <div class="mb-4 col-lg-6">
    <label class="form-label">
      {{ 'serieProposalModule.contactPerson' | translate }}
    </label>

    <div>
      {{ (memberEntities$ | async)[serieProposal.customerPersonId]?.firstName }}
      {{ (memberEntities$ | async)[serieProposal.customerPersonId]?.lastName }}
      <br />
      {{ (memberEntities$ | async)[serieProposal.customerPersonId]?.email }}
      <br />
      {{ (memberEntities$ | async)[serieProposal.customerPersonId]?.mobile }}
    </div>
  </div>
</div>

<div
  *ngIf="serieProposal.type === serieProposalType.REPEATABLE_BOOKING"
  class="row mb-4"
>
  <!-- Days of the week -->
  <div class="mb-4 col-lg-6">
    <label class="form-label">
      {{ 'serieProposalModule.dayOfTheWeek' | translate }}
    </label>

    <div class="mb-2">
      <ng-container *ngFor="let day of daysOfWeek">
        <button
          class="btn btn-white rounded-circle avatar btn-sm pe-none"
          tabindex="-1"
          [ngClass]="{
            'btn-white': !isDaySelected(day),
            'btn-primary': isDaySelected(day)
          }"
          type="button"
          attr.aria-label="{{ 'general.day' + day | translate }}"
        >
          {{ 'general.dayAbbreviation' + day | translate }}
        </button>
      </ng-container>
    </div>
  </div>

  <div class="mb-4">
    <label class="form-label">
      {{ 'serieProposalModule.groupInformation' | translate }}
    </label>

    <p> {{ serieProposal.groupInformation ?? '-' }} </p>
  </div>

  <div *ngFor="let day of selectedDays" class="row">
    <div class="col-lg-6 d-flex align-items-center justify-content-between">
      <div>
        <label class="form-label">
          {{ 'general.day' + day | translate }}
          {{ 'serieProposalModule.startAndEndTime' | translate | lowercase }}
        </label>
        <p>
          {{ getTimesForDay(day).startTime }} -
          {{ getTimesForDay(day).endTime }}
        </p>
      </div>
    </div>
  </div>
</div>

<div class="row">
  <div class="mb-4 col-lg-6">
    <label class="form-label">
      {{ 'serieProposalModule.internalMemo' | translate }}
    </label>
    <p class="mb-0">
      {{ serieProposal.internalMemo ?? '-' }}
    </p>
  </div>
  <div class="mb-4 col-lg-6">
    <label class="form-label">
      {{ 'serieProposalModule.externalMemo' | translate }}
    </label>
    <p class="mb-0">
      {{ serieProposal.externalMemo ?? '-' }}
    </p>
  </div>
</div>
